import React from "react";
import { ReactComponent as IOMLogo } from "assets/logos/iom.svg";
import { ReactComponent as GamCare } from "assets/logos/gamcare.svg";

import * as styles from "./Footer.module.scss";

const IsleOfManFooterContent = () => (
  <>
    <p>
      Felix Operations Limited is a company incorporated in the Isle of Man with
      registration number 022004V, having its registered address at Third Floor,
      34 Hope Street, Douglas, Isle of Man, IM1 1AP.
    </p>
    <p>
      Felix Operations Limited is licensed and regulated by the Isle of Man
      Gambling Supervision Commission, and the holder of an OGRA licence issued
      on the 7<sup>th</sup> of April 2025.
    </p>
    <p>
      All gambling debts are enforceable in Isle of Man courts. 18+, gamble
      responsibly.
    </p>
    <div className={styles.IOMLogos}>
      <a
        href="https://www.isleofmangsc.com/gambling/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IOMLogo width={"2.3125rem"} height={"1.875rem"} />
      </a>
      <a
        href="https://www.gamcare.org.uk/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <GamCare width={"4.375rem"} height={"1.25rem"} />
      </a>
    </div>
  </>
);

export { IsleOfManFooterContent };
